import { ReactNode } from 'react';

// material-ui
import { styled } from '@mui/material/styles';

// third-party
import { SnackbarProvider } from 'notistack';

// project-imports
import { useGetSnackbar } from 'api/snackbar';
import Loader from 'components/Loader';

// assets
import { CloseCircle, InfoCircle, TickCircle, Warning2 } from 'iconsax-reactjs';

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '&.notistack-MuiContent-default': { backgroundColor: theme.palette.primary.main },
  '&.notistack-MuiContent-error': { backgroundColor: theme.palette.error.main },
  '&.notistack-MuiContent-success': { backgroundColor: theme.palette.success.main },
  '&.notistack-MuiContent-info': { backgroundColor: theme.palette.info.main },
  '&.notistack-MuiContent-warning': { backgroundColor: theme.palette.warning.main }
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }: { children: ReactNode }) {
  const { snackbar } = useGetSnackbar();
  const iconSX = { marginRight: 8, fontSize: '1.15rem' };

  if (snackbar === undefined) return <Loader />;

  return (
    <StyledSnackbarProvider
      maxSnack={snackbar.maxStack}
      dense={snackbar.dense}
      iconVariant={
        snackbar.iconVariant === 'useemojis'
          ? {
              success: <TickCircle style={iconSX} />,
              error: <CloseCircle style={iconSX} />,
              warning: <Warning2 style={iconSX} />,
              info: <InfoCircle style={iconSX} />
            }
          : undefined
      }
      hideIconVariant={snackbar.iconVariant === 'hide' ? true : false}
    >
      {children}
    </StyledSnackbarProvider>
  );
}
